module.exports = __webpack_public_path__ + "images/index/img00.dd81869.jpeg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/proimg/children/new/img00.jpeg
// module id = yXkl
// module chunks = 21